import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Select,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Radio,
  Empty,
  Dropdown,
  Menu,
  Modal
} from "antd";

import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import { HomeOutlined, OrderedListOutlined, ArrowUpOutlined, ArrowDownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import videoGalleryService from "../../../services/video-gallery-service";
import AddEditFolderDialog from "./AddEditFolderDialog";
import AddEditVideoDialog from "./AddEditVideoDialog";
import { galleryType } from "../../../constants/app-constants";
import GalleryVideoCard from "../../../components/gallery/video/gallery-card";
import ListVideoCard from "../../../components/gallery/video/list-card";
import fileUtils from "../../../utils/file-utils";
import { Switch } from "react-router-dom";

const { Option } = Select;
const { Panel } = Collapse;
const { confirm } = Modal;


const Video = ({ isHtmlModal }) => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [isShowAddVideoDialog, setIsShowAddVideoDialog] = useState(false);
  const [condition, setCondition] = useState({
    fileName: null,
    type: null,
    parent: 'root',
    path: '',
    folder: false
  });
  const [editFolderData, setEditFolderData] = useState(null);
  const [editVideoData, setEditVideoData] = useState(null);
  const [displayList, setDisplayList] = useState([]);
  const [displayGroup, setDisplayGroup] = useState('a');
  const [currentParent, setCurrentParent] = useState("root");
  const [currentPath, setCurrentPath] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [sortAscFlag, setSortAscFlag] = useState(false);

  useEffect(() => {
    doSearch();
  }, []);

  const onChangeSelection = (value) => {
    setCondition({ ...condition, type: value, parent: null });
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value, parent: null });
  }

  const doSearch = async (payload) => {
    try {
      dispatch(appLoaderAction.enable());
      if (payload) {
        const result = await videoGalleryService.search(payload);
        setCurrentParent(payload.parent);
        setDisplayList(result.list);
      } else {
        const newCondition = { fileName : condition.fileName, type : condition.type, parent: condition.parent  }
        const result = await videoGalleryService.search(newCondition);
        setCurrentParent(condition.parent);
        setCurrentPath(null);
        setDisplayList(result.list);
      }
      dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        dispatch(notifyUtitls.error(err));
    }
  };

  const onOpenFolder = async (value) => {
    try {
      dispatch(appLoaderAction.enable());
      const newCondition = { parent: value.id }
      const result = await videoGalleryService.search(newCondition);
      setCurrentParent(value.id);
      if (currentPath) {
        setCurrentPath([
          ...currentPath,
          value.folderName
        ]);
      } else {
        setCurrentPath([
          value.folderName
        ]);
      }

      setCurrentFolder(value.folderName);
      setDisplayList(result.list);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  }

  /**
   * NMU-529: clearing the filters has to re-run the listing, not just empty the
   * inputs — otherwise the grid keeps showing the previous result set while the
   * form claims no filter is applied. Back to the root folder, which is this
   * page's page 1.
   *
   * `doSearch` is given the cleared payload explicitly: setCondition only takes
   * effect on the next render, so calling it with no argument here would search
   * with the filters this handler just cleared.
   */
  const onClearSearch = () => {
    const cleared = {
      fileName: null,
      type: null,
      parent: 'root',
      folder: false
    };
    setCondition(cleared);
    setCurrentPath(null);
    setCurrentFolder(null);
    doSearch({ fileName: null, type: null, parent: 'root' });
  }

  const displayGroupHandler = (event) => {
    setDisplayGroup(event.target.value);
  }

  const onAddFolder = () => {
    setIsShowAddFileDialog(true);
    setEditFolderData(null);
  }

  const onAddVideo = () => {
    setIsShowAddVideoDialog(true);
    setEditVideoData(null);
  }

  const onCancelAddFolder = () => {
		setIsShowAddFileDialog(false);
		setEditFolderData(null);
	};

  const onAddFolderComplete = () => {
    setIsShowAddFileDialog(false);
    setEditFolderData(null);
    doSearch({parent: currentParent})
	};

  const onCancelAddVideo = () => {
		setIsShowAddVideoDialog(false);
		setEditVideoData(null);
	};

  const onAddVideoComplete = () => {
    setIsShowAddVideoDialog(false);
    setEditVideoData(null);
    doSearch({parent: currentParent})
	};

  const onClickEdit = async (value) => {
    try {
        dispatch(appLoaderAction.enable());
        // const editData = await photoGalleryService.getById({id: id});
        value.folder ? onEditFolder(value) : onEditVideo(value);
        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  }

  const onEditVideo = (data) =>{
    setEditVideoData(data);
    setIsShowAddVideoDialog(true);
  }

  const onEditFolder = (data) =>{
    setEditFolderData(data);
    setIsShowAddFileDialog(true);
  }

  const onConfirmDelete = (id) => {
    confirm({
      title: 'คุณต้องการลบใช่หรือไม่ ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'ยืนยัน',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk() {
        onDelete(id);
      },
      onCancel() {
      },
    });
  }

  const onDelete = async (id) => {
    try {
        dispatch(appLoaderAction.enable());
        await videoGalleryService.remove({deleteId: id});
        dispatch(appLoaderAction.disale());
        notifyUtitls.deleted('สำเร็จ', 'ลบข้อมูลสำเร็จ');
        doSearch({parent: currentParent})
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  };

  const onEmbed = async (id) => {
    dispatch(appLoaderAction.enable());
    await videoGalleryService.generateLinkVideoGalleryById({id: id})
      .then((res) => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(res.link);
        } else {
          let textArea = document.createElement("textarea");
          textArea.value = res.link;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
        }
        notifyUtitls.success('สำเร็จ', 'สร้างลิ้งค์');
      }).catch((err) => {
        notifyUtitls.error(err);
      }).finally(() => {
        dispatch(appLoaderAction.disale());
    });
  }

  const moveFileHandler = async (fileMove, folder) => {
      if (folder.folder !== 'true') {
        try {
          dispatch(appLoaderAction.enable());
          let path = "/"
          if (currentPath) {
            currentPath.forEach((res) => {
              path = path + res + "/";
            });
            path = path + folder.folderName + "/"
          } else {
            path = path + folder.folderName + "/"
          }

          const moveValue = {
            bean: {
              id: fileMove.id,
              fileName: fileMove.fileName,
              type: fileMove.type,
              path: fileMove.path,
              parent: folder.id,
              folder: fileMove.folder,
              newPath: path
            }
          }
          await videoGalleryService.moveFile(moveValue);
          doSearch({parent: currentParent})
          dispatch(appLoaderAction.disale());
          notifyUtitls.success('สำเร็จ', 'ย้ายข้อมูลสำเร็จ');
        } catch (err) {
          dispatch(appLoaderAction.disale());
          notifyUtitls.error(err);
        }
      }
  }

  const downloadHandler = (data) => {
    const downloadUrl = fileUtils.downloadGalleryVideoUrl(
      galleryType.VIDEO,
      data.path,
      data.fileName
    )

    // saveAs(
    //   downloadUrl,
    //   data.fileName
    // );

    var downloadLink = document.createElement("a");
    downloadLink.href = downloadUrl;
    downloadLink.setAttribute(
      'download',
      data.fileName,
    );

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  const onSort = (value) => {
    switch (value) {
      case 'sortName':
        const newDisplayListName = displayList.sort((a, b) => {
          const prevFname = a.folderName || a.fileName;
          const nextFname = b.folderName || b.fileName;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }
        });
        setDisplayList([...newDisplayListName]);
        break;
      case 'sortSize':
        const newDisplayListSize = displayList.sort((a, b) => {
          const prevFname = a.size;
          const nextFname = b.size;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
              if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }          
        });
        setDisplayList([...newDisplayListSize]);
        break;
      case 'sortDate':
        const newDisplayListDate = displayList.sort((a, b) => {
          const prevFname = a.updateTime;
          const nextFname = b.updateTime;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }   
        });
        setDisplayList([...newDisplayListDate]);
        break;
      default:
        break;
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key="sortName" onClick={(event) => onSort(event.key)}>
        Sort by Name
      </Menu.Item>
      <Menu.Item key="sortSize"  onClick={(event) => onSort(event.key)}>
        Sort by Size
      </Menu.Item>
      <Menu.Item key="sortDate"  onClick={(event) => onSort(event.key)}>
        Sort by Date
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <h2>วีดีโอ</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการแกลลอรี่</Breadcrumb.Item>
        <Breadcrumb.Item>วีดีโอ</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex">
        <div>
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button type="primary me-3" onClick={() => onAddVideo()}>
                <Icon.Film className="me-2" size={18} /> อัปโหลดวีดีโอ
              </Button>
            )
          }
        </div>
        <div>
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button className="btn-line me-3" onClick={() => onAddFolder()}>
                <Icon.FolderPlus className="me-1" size={18} /> เพิ่มโฟล์เดอร์
              </Button>
            )
          }
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form 
                layout="vertical"
                initialValues={{
                  parent: 'root'
                }}
              >
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อวีดีโอ" className="mb-0">
                      <Input 
                        name="fileName"
                        value={condition.fileName}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="ชนิดวีดีโอ" className="mb-0" >
                      <Select allowClear value={condition.type} onChange={onChangeSelection}>
                        <Option key="mp4" value="mp4">mp4</Option>
                        <Option key="mod" value="mod">mod</Option>
                        <Option key="movie" value="movie">movie</Option>
                        <Option key="mp4" value="mp4">mod</Option>
                        <Option key="mp4v" value="mp4v">mp4v</Option>
                        <Option key="mpa" value="mpa">mpa</Option>
                        <Option key="mpe" value="mpe">mpe</Option>
                        <Option key="mpeg" value="mpeg">mpeg</Option>
                        <Option key="mpg" value="mpg">mpg</Option>
                        <Option key="avi" value="avi">avi</Option>
                        <Option key="flv" value="flv">flv</Option>
                        <Option key="wmp" value="wmp">wmp</Option>
                        <Option key="wmv" value="wmv">wmv</Option>
                        <Option key="wmx" value="wmx">wmx</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch()}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <h5>วีดีโอ</h5>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '20px' }}>
          <Radio.Group buttonStyle="solid" onChange={displayGroupHandler} value={displayGroup}>
            <Radio.Button key="a" value="a">
              <Icon.Grid size={18} />
            </Radio.Button>
            <Radio.Button key="b" value="b">
              <Icon.List size={18} />
            </Radio.Button>
          </Radio.Group>

          <Dropdown overlay={menu} >
            <Button style={{ height: '32px' }}>
              {
                sortAscFlag === true ? (
                  <ArrowDownOutlined />
                ) : (
                  <ArrowUpOutlined />
                )
              }
              <OrderedListOutlined />
            </Button>
          </Dropdown>
        </div>
        
        <div className="p-3 border ">
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumb>
              <Breadcrumb.Item href="">
                <HomeOutlined />
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => doSearch()}>
                วีดีโอ
              </Breadcrumb.Item>
              {
                currentParent === "root" ? (
                  null
                ) : (
                  <Breadcrumb.Item onClick={() => doSearch({parent: currentParent})}>
                    {currentFolder}
                  </Breadcrumb.Item>
                )
              }
            </Breadcrumb>
          </div>
            {displayGroup === 'a' ? 
              <div className="text-center my-4">
                {displayList ? (
                  <GalleryVideoCard
                    axis={'x'}
                    items={displayList}
                    onRemove={onConfirmDelete}
                    onEdit={onClickEdit}
                    groupValue={galleryType.VIDEO}
                    embedMenuList={onEmbed}
                    editMenuList={onClickEdit}
                    openMenuList={onOpenFolder}
                    moveFile={moveFileHandler}
                    onDownload={downloadHandler}
                  />
                ) : (
                  <Empty />
                )}
              </div> 
              : 
              <div>
                {displayList ? (
                  <ListVideoCard
                      axis={'x'}
                      items={displayList}
                      onRemove={onConfirmDelete}
                      onEdit={onClickEdit}
                      groupValue={galleryType.VIDEO}
                      embedMenuList={onEmbed}
                      editMenuList={onClickEdit}
                      openMenuList={onOpenFolder}
                      moveFile={moveFileHandler}
                      onDownload={downloadHandler}
                  />
                ) : (
                  <Empty />
                )}
              </div>
            }
        </div>
      </Card>

      <AddEditFolderDialog 
          isShow={isShowAddFileDialog}
          editData={editFolderData}
          currentParent={currentParent}
          currentPath={currentPath}
          onCancel={onCancelAddFolder}
          onSaveComplete={onAddFolderComplete}>
      </AddEditFolderDialog>

      <AddEditVideoDialog 
          isShow={isShowAddVideoDialog}
          editData={editVideoData}
          currentParent={currentParent}
          currentFolder={currentFolder}
          currentPath={currentPath}
          onCancel={onCancelAddVideo}
          onSaveComplete={onAddVideoComplete}>
      </AddEditVideoDialog>

    </div>
  );
};

export default Video;
